import { Box, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const PipingContainerStyled = styled(Box).attrs({
  mx: { sm: '500' },
  mt: { sm: '500' },
  px: { sm: '500' },
  pt: { sm: '550' },
  pb: { sm: '500' },
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[200]} ${theme.radii[200]} 0 0;
  `}
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;
export const FooterStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'flex-end' } })`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const PipingFooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
    margin-left: ${theme.spacings[400]};
  `}
`;
